 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + ".buttplug.min.js"
 	}

 	// object to store loaded and loading wasm modules
 	var installedWasmModules = {};

 	function promiseResolve() { return Promise.resolve(); }

 	var wasmImportObjects = {
 		30: function() {
 			return {
 				"./buttplug_rs_ffi_bg.js": {
 					"__wbindgen_object_drop_ref": function(p0i32) {
 						return installedModules[28].exports["Fb"](p0i32);
 					},
 					"__wbindgen_cb_drop": function(p0i32) {
 						return installedModules[28].exports["sb"](p0i32);
 					},
 					"__wbg_log_aedd6896ca471fe6": function(p0i32,p1i32) {
 						return installedModules[28].exports["A"](p0i32,p1i32);
 					},
 					"__wbindgen_string_new": function(p0i32,p1i32) {
 						return installedModules[28].exports["Hb"](p0i32,p1i32);
 					},
 					"__wbindgen_object_clone_ref": function(p0i32) {
 						return installedModules[28].exports["Eb"](p0i32);
 					},
 					"__wbindgen_is_string": function(p0i32) {
 						return installedModules[28].exports["Bb"](p0i32);
 					},
 					"__wbg_log_02e20a3c32305fb7": function(p0i32,p1i32) {
 						return installedModules[28].exports["y"](p0i32,p1i32);
 					},
 					"__wbg_log_5c7513aa8c164502": function(p0i32,p1i32,p2i32,p3i32,p4i32,p5i32,p6i32,p7i32) {
 						return installedModules[28].exports["z"](p0i32,p1i32,p2i32,p3i32,p4i32,p5i32,p6i32,p7i32);
 					},
 					"__wbg_mark_abc7631bdced64f0": function(p0i32,p1i32) {
 						return installedModules[28].exports["B"](p0i32,p1i32);
 					},
 					"__wbg_measure_c528ff64085b7146": function(p0i32,p1i32,p2i32,p3i32) {
 						return installedModules[28].exports["C"](p0i32,p1i32,p2i32,p3i32);
 					},
 					"__wbg_new_693216e109162396": function() {
 						return installedModules[28].exports["I"]();
 					},
 					"__wbg_stack_0ddaca5d1abfb52f": function(p0i32,p1i32) {
 						return installedModules[28].exports["ib"](p0i32,p1i32);
 					},
 					"__wbg_error_09919627ac0992f5": function(p0i32,p1i32) {
 						return installedModules[28].exports["o"](p0i32,p1i32);
 					},
 					"__wbg_Window_f826a1dec163bacb": function(p0i32) {
 						return installedModules[28].exports["a"](p0i32);
 					},
 					"__wbindgen_is_undefined": function(p0i32) {
 						return installedModules[28].exports["Cb"](p0i32);
 					},
 					"__wbg_WorkerGlobalScope_967d186155183d38": function(p0i32) {
 						return installedModules[28].exports["b"](p0i32);
 					},
 					"__wbg_instanceof_Window_c4b70662a0d2c5ec": function(p0i32) {
 						return installedModules[28].exports["w"](p0i32);
 					},
 					"__wbg_navigator_480e592af6ad365b": function(p0i32) {
 						return installedModules[28].exports["G"](p0i32);
 					},
 					"__wbg_clearTimeout_2c1ba0016d8bca41": function(p0i32,p1i32) {
 						return installedModules[28].exports["i"](p0i32,p1i32);
 					},
 					"__wbg_setTimeout_df66d951b1726b78": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["ab"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_data_9e55e7d79ab13ef1": function(p0i32) {
 						return installedModules[28].exports["n"](p0i32);
 					},
 					"__wbg_value_84cefeb2408dfe15": function(p0i32) {
 						return installedModules[28].exports["ob"](p0i32);
 					},
 					"__wbg_setoncharacteristicvaluechanged_75ec7773e310719c": function(p0i32,p1i32) {
 						return installedModules[28].exports["db"](p0i32,p1i32);
 					},
 					"__wbg_readValue_eeee467eee29d9ab": function(p0i32) {
 						return installedModules[28].exports["U"](p0i32);
 					},
 					"__wbg_startNotifications_89d52c5da12f4a73": function(p0i32) {
 						return installedModules[28].exports["jb"](p0i32);
 					},
 					"__wbg_writeValue_5045e53d65cf4416": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["rb"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_target_cc69dde6c2d9ec90": function(p0i32) {
 						return installedModules[28].exports["lb"](p0i32);
 					},
 					"__wbindgen_string_get": function(p0i32,p1i32) {
 						return installedModules[28].exports["Gb"](p0i32,p1i32);
 					},
 					"__wbg_requestDevice_94797563349e93d8": function(p0i32,p1i32) {
 						return installedModules[28].exports["V"](p0i32,p1i32);
 					},
 					"__wbg_id_a762586fc34a710d": function(p0i32,p1i32) {
 						return installedModules[28].exports["v"](p0i32,p1i32);
 					},
 					"__wbg_name_48ead2aa58c91524": function(p0i32,p1i32) {
 						return installedModules[28].exports["F"](p0i32,p1i32);
 					},
 					"__wbg_gatt_bca8d85b97b18ec3": function(p0i32) {
 						return installedModules[28].exports["p"](p0i32);
 					},
 					"__wbg_setongattserverdisconnected_5e832e08b6b5f423": function(p0i32,p1i32) {
 						return installedModules[28].exports["fb"](p0i32,p1i32);
 					},
 					"__wbg_clearTimeout_c1f246d6874c0679": function(p0i32,p1i32) {
 						return installedModules[28].exports["j"](p0i32,p1i32);
 					},
 					"__wbg_setTimeout_5314850184d61a44": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["Z"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_bluetooth_cc8e053613d8eeca": function(p0i32) {
 						return installedModules[28].exports["c"](p0i32);
 					},
 					"__wbg_setonopen_33b75427f7db7ce1": function(p0i32,p1i32) {
 						return installedModules[28].exports["hb"](p0i32,p1i32);
 					},
 					"__wbg_setonerror_cb55f0521ac0da3a": function(p0i32,p1i32) {
 						return installedModules[28].exports["eb"](p0i32,p1i32);
 					},
 					"__wbg_setonmessage_ca5f75e4a84134ef": function(p0i32,p1i32) {
 						return installedModules[28].exports["gb"](p0i32,p1i32);
 					},
 					"__wbg_new_982fe22cd93d67f7": function(p0i32,p1i32) {
 						return installedModules[28].exports["K"](p0i32,p1i32);
 					},
 					"__wbg_close_f2a10c1de90df5f0": function(p0i32) {
 						return installedModules[28].exports["k"](p0i32);
 					},
 					"__wbg_send_503c2e7652e95bf5": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["Y"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_connect_e3ccb7d88e903a95": function(p0i32) {
 						return installedModules[28].exports["l"](p0i32);
 					},
 					"__wbg_getPrimaryService_e624e0982bcd83b1": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["r"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_getCharacteristic_7d2869d1ad7151d2": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["q"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_getRandomValues_98117e9a7e993920": function(p0i32,p1i32) {
 						return installedModules[28].exports["s"](p0i32,p1i32);
 					},
 					"__wbg_randomFillSync_64cc7d048f228ca8": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["T"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_process_2f24d6544ea7b200": function(p0i32) {
 						return installedModules[28].exports["R"](p0i32);
 					},
 					"__wbindgen_is_object": function(p0i32) {
 						return installedModules[28].exports["Ab"](p0i32);
 					},
 					"__wbg_versions_6164651e75405d4a": function(p0i32) {
 						return installedModules[28].exports["pb"](p0i32);
 					},
 					"__wbg_node_4b517d861cbcb3bc": function(p0i32) {
 						return installedModules[28].exports["Q"](p0i32);
 					},
 					"__wbg_modulerequire_3440a4bcf44437db": function(p0i32,p1i32) {
 						return installedModules[28].exports["D"](p0i32,p1i32);
 					},
 					"__wbg_crypto_98fc271021c7d2ad": function(p0i32) {
 						return installedModules[28].exports["m"](p0i32);
 					},
 					"__wbg_msCrypto_a2cdb043d2bfe57f": function(p0i32) {
 						return installedModules[28].exports["E"](p0i32);
 					},
 					"__wbg_new_949bbc1147195c4e": function() {
 						return installedModules[28].exports["J"]();
 					},
 					"__wbg_newnoargs_be86524d73f67598": function(p0i32,p1i32) {
 						return installedModules[28].exports["M"](p0i32,p1i32);
 					},
 					"__wbg_call_888d259a5fefc347": function(p0i32,p1i32) {
 						return installedModules[28].exports["h"](p0i32,p1i32);
 					},
 					"__wbg_new_0b83d3df67ecb33e": function() {
 						return installedModules[28].exports["H"]();
 					},
 					"__wbg_push_284486ca27c6aa8b": function(p0i32,p1i32) {
 						return installedModules[28].exports["S"](p0i32,p1i32);
 					},
 					"__wbg_buffer_45280fecb82c83df": function(p0i32) {
 						return installedModules[28].exports["e"](p0i32);
 					},
 					"__wbg_byteLength_c9e4f1b2bae8fc4d": function(p0i32) {
 						return installedModules[28].exports["f"](p0i32);
 					},
 					"__wbg_call_346669c262382ad7": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["g"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_resolve_d23068002f584f22": function(p0i32) {
 						return installedModules[28].exports["W"](p0i32);
 					},
 					"__wbg_then_2fcac196782070cc": function(p0i32,p1i32) {
 						return installedModules[28].exports["mb"](p0i32,p1i32);
 					},
 					"__wbg_then_8c2d62e8ae5978f7": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["nb"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_self_c6fbdfc2918d5e58": function() {
 						return installedModules[28].exports["X"]();
 					},
 					"__wbg_window_baec038b5ab35c54": function() {
 						return installedModules[28].exports["qb"]();
 					},
 					"__wbg_globalThis_3f735a5746d41fbd": function() {
 						return installedModules[28].exports["t"]();
 					},
 					"__wbg_global_1bc0b39582740e95": function() {
 						return installedModules[28].exports["u"]();
 					},
 					"__wbg_buffer_397eaa4d72ee94dd": function(p0i32) {
 						return installedModules[28].exports["d"](p0i32);
 					},
 					"__wbg_newwithbyteoffsetandlength_4b9b8c4e3f5adbff": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["O"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_new_a7ce447f15ff496f": function(p0i32) {
 						return installedModules[28].exports["L"](p0i32);
 					},
 					"__wbg_set_969ad0a60e51d320": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["cb"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_length_1eb8fc608a0d4cdb": function(p0i32) {
 						return installedModules[28].exports["x"](p0i32);
 					},
 					"__wbg_newwithlength_929232475839a482": function(p0i32) {
 						return installedModules[28].exports["P"](p0i32);
 					},
 					"__wbg_newwithbyteoffset_b638bad8cc090f32": function(p0i32,p1i32) {
 						return installedModules[28].exports["N"](p0i32,p1i32);
 					},
 					"__wbg_subarray_8b658422a224f479": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["kb"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_set_82a4e8a85e31ac42": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["bb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_debug_string": function(p0i32,p1i32) {
 						return installedModules[28].exports["zb"](p0i32,p1i32);
 					},
 					"__wbindgen_throw": function(p0i32,p1i32) {
 						return installedModules[28].exports["Ib"](p0i32,p1i32);
 					},
 					"__wbindgen_memory": function() {
 						return installedModules[28].exports["Db"]();
 					},
 					"__wbindgen_closure_wrapper256": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["tb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper258": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["ub"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper260": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["vb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper262": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["wb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper2880": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["xb"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_closure_wrapper4637": function(p0i32,p1i32,p2i32) {
 						return installedModules[28].exports["yb"](p0i32,p1i32,p2i32);
 					}
 				}
 			};
 		},
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// Fetch + compile chunk loading for webassembly

 		var wasmModules = {"1":[30]}[chunkId] || [];

 		wasmModules.forEach(function(wasmModuleId) {
 			var installedWasmModuleData = installedWasmModules[wasmModuleId];

 			// a Promise means "currently loading" or "already loaded".
 			if(installedWasmModuleData)
 				promises.push(installedWasmModuleData);
 			else {
 				var importObject = wasmImportObjects[wasmModuleId]();
 				var req = fetch(__webpack_require__.p + "" + {"30":"b0219b34bc18e1ad0240"}[wasmModuleId] + ".module.wasm");
 				var promise;
 				if(importObject instanceof Promise && typeof WebAssembly.compileStreaming === 'function') {
 					promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
 						return WebAssembly.instantiate(items[0], items[1]);
 					});
 				} else if(typeof WebAssembly.instantiateStreaming === 'function') {
 					promise = WebAssembly.instantiateStreaming(req, importObject);
 				} else {
 					var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
 					promise = bytesPromise.then(function(bytes) {
 						return WebAssembly.instantiate(bytes, importObject);
 					});
 				}
 				promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
 					return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
 				}));
 			}
 		});
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// object with all WebAssembly.instance exports
 	__webpack_require__.w = {};

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 26);
 	})();

 	webpackJsonpCallback([[], {}, 0, [1]]);
 	return startupResult;
